import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Button from '../../../atoms/buttons/Button';
import Modal from '../Modal';

const DeleteTaxConfirmationModal = (props) => {
  const {
    showModal,
    changeModalVisibility,
    title,
    confirmButtonId,
    cancelButtonId,
    isLoading,
    onConfirmationFunction,
  } = props;

  const cssClass = showModal ? 'd-block' : 'd-none';

  return (
    <Modal isLoading={isLoading} className={`${cssClass}`}>
      <div className='--confirmation'>
        <div className='text-header h3 text-center'>
          {props.intl.messages[title]}
        </div>

        <div className='d-flex w-100 justify-content-center'>
          <Button
            id='cancelAction'
            className='button button-outline px-5 me-2'
            onClick={changeModalVisibility}
          >
            <FormattedMessage id={cancelButtonId || 'cancelAction'} />
          </Button>

          <Button
            id={confirmButtonId}
            className='button bg-red-300 color-ix-white px-5 ms-2'
            onClick={onConfirmationFunction}
          >
            <FormattedMessage id={confirmButtonId} />
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default injectIntl(DeleteTaxConfirmationModal);
